import i18next from 'i18next'
import { showToast } from '../components/Toast/Toast'
import { isAxiosError } from 'axios'

export enum ErrorCodes {
  GENERIC_ERROR = 1000,
  INVALID_CREATION_URL = 1001,
  FETCH_API_KEYS_FAILED = 2001,
  FETCH_VEHICLES_FAILED = 2002,
  INVALID_PROVIDER = 2003,
  REVERSE_GEOCODING_FAILED = 3001,
  MAP_API_DOWN = 3002,
  API_KEY_REJECTED = 4001,
  CREATE_API_KEY_FAILED = 5001,
  UPDATE_API_KEY_FAILED = 5002,
  DELETE_API_KEY_FAILED = 5003,
}

const ERROR_TRANSLATIONS: Record<ErrorCodes, string> = {
  [ErrorCodes.GENERIC_ERROR]: 'errors.genericError',
  [ErrorCodes.FETCH_API_KEYS_FAILED]: 'errors.fetchApiKeysFailed',
  [ErrorCodes.INVALID_CREATION_URL]: 'errors.invalidCreationUrl',
  [ErrorCodes.FETCH_VEHICLES_FAILED]: 'errors.fetchVehiclesFailed',
  [ErrorCodes.REVERSE_GEOCODING_FAILED]: 'errors.fetchLocationDetailsFailed',
  [ErrorCodes.MAP_API_DOWN]: 'errors.fetchLocationDetailsFailed',
  [ErrorCodes.API_KEY_REJECTED]: 'errors.providerRejectedApiKey',
  [ErrorCodes.INVALID_PROVIDER]: 'errors.invalidCreationUrl',
  [ErrorCodes.CREATE_API_KEY_FAILED]: 'errors.createApiKeyFailed',
  [ErrorCodes.UPDATE_API_KEY_FAILED]: 'errors.updateApiKeyFailed',
  [ErrorCodes.DELETE_API_KEY_FAILED]: 'errors.deleteApiKeyFailed',
}

export function showError(code: ErrorCodes, error?: unknown) {
  const requestId = getRequestIdFromError(error)

  const messageKey = ERROR_TRANSLATIONS[code] || 'errors.genericError'
  const translatedMessage = i18next.t(messageKey, { error: code })

  console.error(`Error (${code}):`, error)
  showToast(translatedMessage, requestId)
}

function getRequestIdFromError(error: unknown) {
  if (isAxiosError(error)) {
    return error.response?.headers['x-amzn-requestid']
  }
  return undefined
}
